<template>
  <div class="product-list">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="课程名称">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入课程名称"></el-input>
        </el-form-item>
        <el-form-item label="所属分类">
          <el-select size="small" v-model="searchForm.categoryId" placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name" :value="item.categoryId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否精选">
          <el-select size="small" v-model="searchForm.lesson_type" placeholder="请选择是否精选">
            <el-option label="全部" value=""></el-option>
            <el-option label="非精选课程" value="0"></el-option>
            <el-option label="精选课程" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getTableList">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加产品-->
    <div class="common-level-rail" style="display:flex;">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加课程</el-button>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%">
          <!-- v-loading="loading" -->
          <el-table-column prop="name" label="课程名称" width="150px">
          </el-table-column>
          <el-table-column prop="lessonCategory.name" label="所属分类">
          </el-table-column>
          <el-table-column prop="image.filePath" label="课程分类图片">
            <template slot-scope="scope">
              <img :src="scope.row.image.filePath" width="30" height="30" />
            </template>
          </el-table-column>
          <el-table-column prop="lesson_type" label="是否精选">
            <template slot-scope="scope">
              <span v-if="scope.row.lesson_type==0">非精选课程</span>
              <span v-else>精选课程</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="file_address" label="视频地址"></el-table-column>
          <el-table-column prop="message" label="课程概要"></el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="primary" size="small">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="danger" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <!--编辑-->
    <Edit v-if="open_edit" :open_edit="open_edit" :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
import Technician from "@/api/technician.js";
import Edit from "./edit.vue";
import Add from "./add.vue";
import { deepClone } from "@/utils/base.js";
export default {
  components: {
    Add,
    Edit
  },
  data() {
    return {
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      searchForm: {
        name: "",
        categoryId: "",
        lesson_type: ""
      },
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      categoryList: [],
     
    };
  },
  created() {
    this.getcalsslist();
    /*获取列表*/
    this.getTableList();
  },
  methods: {

    // 课程分类列表
    getcalsslist() {
      let self = this;
      Technician.coursegetCategory({}, true)
        .then(data => {
          self.categoryList = data.data.list;
        })
        .catch(error => {});
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      Technician.courselessonList(Params, true)
        .then(data => {
          self.loading = false;
          if (data.code != 1) return;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick() {
      this.open_add = true;
    },

    /*打开编辑*/
    editClick(item) {
      this.userModel = deepClone(item);
      this.open_edit = true;
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getTableList();
        }
      }
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getTableList();
        }
      }
    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("删除后不可恢复，确认删除该记录吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          Technician.courselessonDel({
            lesson_id: row.lesson_id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getTableList();
          });
        });
    }
  }
};
</script>

<style scoped  lang='scss'>
.s_flex {
  display: flex;
  justify-content: space-between;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/train/center/course/index.vue